import React, { useEffect, useState } from 'react'

import { Button, Form, Input, Modal } from 'antd'

const ArtVideoEditForm = ({ toLoad, visible, onSubmit, onCancel }) => {
  //destructures props
  const [form] = Form.useForm()
  const [video, setVideo] = useState('')
  const [modelVisible, setModalVisible] = useState(false)
  useEffect(() => {
    if (toLoad && visible) {
      setVideo(toLoad)
      form.setFieldsValue({
        video: video
      })
    }
  }, [toLoad, visible])

  // const videoChangeHandler = (e) => {
  //     if (e.target.value === "") {
  //         setVideo(e)
  //     } else {
  //         let profVid = "https://www.youtube.com/embed/";
  //         const splitSlash = e.target.value.split("/");
  //         if (splitSlash.length > 0) {
  //             profVid = profVid + splitSlash[splitSlash.length - 1];
  //             setVideo(profVid)
  //         }
  //     }
  // };

  return (
    <Modal
      visible={visible}
      title='Edit Art Story Video'
      okText='OK'
      onCancel={onCancel}
      width={'66vw'}
      style={{ top: 20 }}
      onOk={() => {
        onSubmit(video)
      }}
    >
      <div
        style={{
          width: '100%',
          height: '66vh',
          paddingTop: 6,
          paddingBottom: 6,
          paddingRight: 24,
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <p>
          <i>
            Use a video to introduce yourself, your unique art process, favorite collections, or your story as an artist.
            We support YouTube and Vimeo links to upload videos.{' '}
            <a style={{ color: 'black', textDecoration: 'underline' }} href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
              Learn More
            </a>
            .
          </i>
        </p>
        <Form
          form={form}
          layout={'vertical'}
          initialValues={{
            video: video
          }}
        >
          <Form.Item name='video' label='Youtube Video Link: '>
            <Input
              value={video}
              onChange={(e) => {
                setVideo(e.target.value)
              }}
              placeholder='Enter YouTube Share Link'
            />
          </Form.Item>
        </Form>
        <Button
          type='link'
          onClick={() => {
            setModalVisible(true)
          }}
        >
          Video not showing in preview?
        </Button>
        <Modal
          title='Troubleshooting'
          visible={modelVisible}
          onOk={() => {
            setModalVisible(false)
          }}
          onCancel={() => {
            setModalVisible(false)
          }}
        >
          <div>
            1. Make sure you are using your YouTube video's Share Link and not the URL. Find this link by clicking 'Share' from your YouTube
            video, and copying the link.
          </div>
          <div>2. If this still did not work, send us a message, and we will work on fixing this right away.</div>
        </Modal>
      </div>
    </Modal>
  )
}

export default ArtVideoEditForm
